import { render, staticRenderFns } from "./CarouselConfig.vue?vue&type=template&id=4dc2521e&scoped=true"
import script from "./CarouselConfig.vue?vue&type=script&lang=js"
export * from "./CarouselConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc2521e",
  null
  
)

export default component.exports